import { gallery_image } from '@components/blocks/images/logic';

// EPS espone ogni scatto come dizionario di varianti ('1000px', '200px'), ma sul
// path resta il token di size del CDN: la gallery lo sostituisce perché serve
// griglia e lightbox da due varianti diverse, il carousel usa il 1000px così com'è.
export const property_gallery_images = (property = {}) => {
  const { images = [] } = property;

  return images.map((image) => gallery_image(image['1000px']));
};

export const room_carousel_images = (room = {}) => {
  const { images = [] } = room;

  return images.map((image) => ({
    url: image['1000px'],
    thumbnail: image['200px'],
  }));
};
